import { useCallback } from 'react';
import type { BrightnessContrastValue } from '../../lib/adjustments/brightness-contrast';
import { RangeRow } from './RangeRow';
import type { AdjustmentPanelProps } from './registry';

export function BrightnessContrastPanel({
  value,
  onChange,
}: AdjustmentPanelProps<BrightnessContrastValue>) {
  const set = useCallback(
    (patch: Partial<BrightnessContrastValue>) => onChange({ ...value, ...patch }),
    [onChange, value],
  );

  return (
    <div className="space-y-3">
      <RangeRow
        label="Brightness"
        min={-100}
        max={100}
        step={1}
        value={value.brightness}
        onChange={(v) => set({ brightness: v })}
      />
      <RangeRow
        label="Contrast"
        min={-100}
        max={100}
        step={1}
        value={value.contrast}
        onChange={(v) => set({ contrast: v })}
      />
    </div>
  );
}
